export default "__VITE_ASSET__55be19ad__"